import { Clear, ErrorCircle } from '@ori-ui/icons';
import { styled, LinearProgress } from '@ori-ui/mui';

const flexCenter = {
  display: 'flex',
  alignItems: 'center',
};

export const StyledListItem = styled('li')(({ theme }) => ({
  position: 'relative',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const StyledDivContent = styled('div')(({ theme }) => ({
  ...flexCenter,
  justifyContent: 'space-between',
}));

export const StyledSpanInfo = styled('span')(({ theme }) => ({
  ...flexCenter,
  maxWidth: 'calc(100% - 50px)',
  width: '100%',
}));

export const StyledSpanThumb = styled('span')(({ theme }) => ({
  ...flexCenter,
  justifyContent: 'center',
  minWidth: '80px',
  minHeight: '80px',
  marginRight: theme.spacing(3),
}));

export const StyledSpanActions = styled('span')(({ theme }) => ({
  ...flexCenter,
  justifyContent: 'flex-end',
}));

export const StyledSpanFile = styled('span')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
}));

export const StyledSpanFileName = styled('span')(({ theme }) => ({
  display: 'block',
  overflow: 'hidden',
  color: theme.palette.text.primary,
  fontSize: '14px',
  lineHeight: '19px',
  textOverflow: 'ellipsis',
  whitespace: 'nowrap',
}));

export const StyledSpanFileNameLink = styled('a')(({ theme }) => ({
  display: 'block',
  overflow: 'hidden',
  color: theme.palette.text.primary,
  fontSize: '14px',
  lineHeight: '19px',
  textOverflow: 'ellipsis',
  whitespace: 'nowrap',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
}));

export const StyledSpanFileSize = styled('span')(({ theme }) => ({
  color: theme.palette.grey.A700,
  fontSize: '11px',
  lineHeight: '18px',
}));

export const StyledErrorIcon = styled(ErrorCircle)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '35px',
  lineHeight: '24px',
}));

export const StyledDeleteIcon = styled(Clear)(({ theme }) => ({
  fontSize: '23px',
  lineHeight: '16px',
  '&:hover': {
    background: 'transparent',
    color: theme.palette.primary.main,
  },
  marginRight: theme.spacing(3),
}));

export const StyledProgress = styled(LinearProgress)(({ theme }) => ({
  position: 'absolute',
  right: 0,
  bottom: '5px',
  left: 0,
}));
